/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Clients_Score_MatchInputs */

const cs_clients_score_match = /** @type {(inputs: Clients_Score_MatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shoda ${i?.n}`)
};

const en_clients_score_match = /** @type {(inputs: Clients_Score_MatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Match ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Match {n}" |
*
* @param {Clients_Score_MatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_score_match = /** @type {((inputs: Clients_Score_MatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Score_MatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_score_match(inputs)
	return cs_clients_score_match(inputs)
});